import './App.css';
import {Container,Input} from "reactstrap"
import Main from "./components/MainPage"
import Growth from "./components/Growth"
import Total from "./components/Total"
import Enteral from "./components/Enteral"
import References from "./components/References"
import {BrowserRouter as Router, Route, Switch, Redirect} from "react-router-dom"
import PlotGraph from './components/PlotGraph';
import Plot from "./components/PlotG"
import Scores from "./components/Scores"
import CalculateTotal from './components/CalculateTotal';
import FeedingRate from './components/FeedingRate';
import FeedingFreq from './components/FeedingFreq';
import CalcFeed from "./components/CalcFeed"
import CalcFeedRate from "./components/CalcFeedRate"
import ActionPlan from "./components/ActionPlan"
import PhoneBreakpoint from "./responsive_utils/phone_breakpoint";
import DesktopBreakpoint from "./responsive_utils/desktop_breakpoint";
import TabletBreakpoint from "./responsive_utils/tablet_breakpoint"


function App() {
  return (
    <>

    <DesktopBreakpoint>
      <div className = "switch__tomobile">
        <h1> Mobile View only </h1>
      </div>
    </DesktopBreakpoint>

    <TabletBreakpoint>
      <div className = "switch__tomobile">
        <h1> Mobile View only</h1>
      </div>
    </TabletBreakpoint> 

      <PhoneBreakpoint>
        <>
        <Router>
          <Route exact path = "/">
            <Redirect to = "/home"/>
          </Route>
        <Route exact path = "/home" component ={Main}>
          <Main/>
          </Route>
          <Route exact path ="/growth" component={Growth}>
            <Growth/>
          </Route>
          <Route exact path ="/graph" component={PlotGraph}>
            <PlotGraph/>
          </Route>
          <Route exact path ="/plot" component={Plot}>
            <Plot/>
          </Route>
          <Route exact path ="/z-score" component={Scores}>
            <Scores/>
          </Route>
          <Route exact path ="/total" component= {Total}>
              <Total/>
          </Route>
          <Route exact path ="/calculate-total" component= {Total}>
              <CalculateTotal/>
          </Route>
          <Route exact path ="/enteral" component= {Enteral}>
              <Enteral/>
          </Route>
          <Route exact path ="/feeding-rate" component= {FeedingRate}>
              <FeedingRate/>
          </Route>
          <Route exact path ="/feeding-frequency" component= {FeedingFreq}>
              <FeedingFreq/>
          </Route>
          <Route exact path ="/calculate-feeding" component= {CalcFeed}>
              <CalcFeed/>
          </Route>
          <Route exact path = "/calculate-fr" component = {CalcFeedRate}>
            <CalcFeedRate/>
          </Route>
          <Route exact path ="/action-plan" component= {ActionPlan}>
              <ActionPlan/>
          </Route>
          <Route exact path ="/references" component= {References}>
              <References/>
          </Route>
          </Router>    
      </>
      
      </PhoneBreakpoint>
    </>
  );
}

export default App;
